/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "igniteui-react-core";
/**
 * Indicates what type of click action will activate edit mode.
 */
export var EditModeClickAction = /*@__PURE__*/ (function (EditModeClickAction) {
    /**
     * Mouse clicks will be ignored for edit mode activation.
     */
    EditModeClickAction[EditModeClickAction["None"] = 0] = "None";
    /**
     * A single click is required to enter edit mode.
     */
    EditModeClickAction[EditModeClickAction["SingleClick"] = 1] = "SingleClick";
    /**
     * A double click is required to enter edit mode.
     */
    EditModeClickAction[EditModeClickAction["DoubleClick"] = 2] = "DoubleClick";
    return EditModeClickAction;
})({});
/**
 * @hidden
 */
export var EditModeClickAction_$type = /*@__PURE__*/ markEnum('EditModeClickAction', 'None,0|SingleClick,1|DoubleClick,2');
//# sourceMappingURL=EditModeClickAction.js.map
